import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/page-about-us/page-about-us-view.tsx");
